
import { Component, Prop, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import SelectPulldownButton from '@/components/organisms/SelectPulldownButton.vue'

/**
 * 教材選択ページのメインパネル
 */
@Component({
  components: {
    PanelFrame,
    ImageBase,
    SelectPulldownButton,
  },
})
export default class SelectStudyCategoryMainPanel extends Vue {
  /** 画像URL */
  @Prop()
  private textbookImagePath!: string | null

  /** 選択系汎用ボタン押下時のイベント */
  @Prop()
  private onSelectPulldownButton!: () => void

  /** 学習教材に紐づく単元の数 */
  @Prop()
  private curriculumUnitCount!: number
}
